import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { createElement, FC, MouseEventHandler, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import EmptyState from '../../component/compound/ProjectsList/EmptyState';
import { SCREEN_LARGE } from '../../constant/pageWidth';
import { SPACING_HUGE, SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import mq from '../../styleUtility/mediaquery';

type Props = {
  onClickNewProjectButton: MouseEventHandler<HTMLElement>;
  onMount: () => void;
  className?: string;
};

const TrialProjectsListPage: FC<Props> = ({ onClickNewProjectButton, onMount, className }) => {
  useEffect(() => {
    onMount();
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root className={className}>
      <Heading>
        <Title>
          <FormattedMessage id="projects_list_page.title" />
        </Title>
        <StyledButton variant="contained" color="primary" onClick={onClickNewProjectButton}>
          <FormattedMessage id="projects_list_page.create_new_project" />
        </StyledButton>
      </Heading>
      <TabContainer>
        <EmptyStateWrapper>
          <EmptyState className={className} />
        </EmptyStateWrapper>
      </TabContainer>
    </Root>
  );
};

const Root = styled('div')({
  width: 'auto',
  maxWidth: SCREEN_LARGE,
  marginTop: SPACING_HUGE,
  marginRight: 'auto',
  marginLeft: 'auto',
  paddingBottom: SPACING_UNIT * 12,
  [mq('sp')]: {
    paddingLeft: SPACING_REGULAR,
    paddingRight: SPACING_REGULAR,
  },
});

const Heading = styled('div')({
  ...gridLayoutContainer({
    justifyContent: 'space-between',
    columns: ['1fr', 'auto'],
    rows: ['auto'],
    areas: [['title', 'button']],
  }),
  marginBottom: SPACING_UNIT * 7,
  [mq('sp')]: {
    ...gridLayoutContainer({
      justifyContent: 'space-between',
      columns: ['100%'],
      rows: ['auto', '8px', 'auto'],
      areas: [['title'], ['.'], ['button']],
    }),
    marginBottom: SPACING_UNIT * 3,
  },
});

const Title = styled(Typography)({
  ...gridLayoutItem('title'),
  fontSize: theme.typography.h5.fontSize,
});

const TabContainer = styled('div')();

export const StyledButton = styled(Button)({
  ...gridLayoutItem('button'),
  whiteSpace: 'nowrap',
  [mq('sp')]: {
    justifySelf: 'end',
  },
});

const EmptyStateWrapper = styled('div')({
  textAlign: 'center',
  marginBottom: SPACING_REGULAR,
});

export default TrialProjectsListPage;
